import { render, staticRenderFns } from "./RegionView.vue?vue&type=template&id=2878dfbb&scoped=true"
import script from "./RegionView.vue?vue&type=script&lang=js"
export * from "./RegionView.vue?vue&type=script&lang=js"
import style0 from "./RegionView.vue?vue&type=style&index=0&id=2878dfbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878dfbb",
  null
  
)

export default component.exports